import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLinkActive, RouterModule } from '@angular/router';

@Component({
  selector: 'app-cms-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, RouterLinkActive],
  templateUrl: './cms-sidebar.component.html',
  styleUrl: './cms-sidebar.component.scss',
})
export class CmsSidebarComponent {}
